import { createStore as _createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

import filter from '@/store/modules/filter'
import child from '@/store/modules/child'
import payment from '@/store/modules/payment'

const STORAGE_KEY = 'vuex'

/**
 * Converts a given input string to a binary string representation. Btoa expects valid ASCII string
 *
 * @param {string} input - The input string to be converted.
 * @returns {string} - The binary string representation of the input.
 */
function toBinaryString(input) {
  return encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (match, p1) =>
    String.fromCharCode(parseInt(p1, 16))
  )
}

const vuexPersistence = new VuexPersistence({
  storage: {
    getItem: () => {
      const store = window.sessionStorage.getItem(STORAGE_KEY)
      if (!store) return null
      return JSON.parse(atob(store))
    },
    setItem: (key, value) => {
      if (key == null || value == null) return
      const safeBinaryString = toBinaryString(value)
      sessionStorage.setItem(key, btoa(safeBinaryString))
    }
  },
  modules: ['payment'],
  reducer: (state) => ({ summary: state?.payment?.summary })
})

export default _createStore({
  modules: {
    filter,
    child,
    payment
  },
  plugins: [vuexPersistence.plugin]
})
